import { render, staticRenderFns } from "./detailsInfo.vue?vue&type=template&id=3dc75089"
import script from "./detailsInfo.vue?vue&type=script&lang=js"
export * from "./detailsInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports